import React from "react";
import { IMdaePopupFooterProps } from "./index";
import "./index.scss";
const MdaePopupFooter: React.FC<IMdaePopupFooterProps> = (props) => {
  return (
    <div className={"sys-mdae-popup-footer-container"}>
      {!props.isHideTopBorder && (
        <div className={"sys-mdae-popup-footer-border"}></div>
      )}
      <div className="mdae-popup-footer sys-mdae-popup-footer">
        {props.children}
      </div>
    </div>
  );
};
export { MdaePopupFooter };
